import React, { Component } from 'react';
import { connect } from 'react-redux';
import shortid from 'shortid';
import Field from '../Field';
import {
	buildFieldIdList,
	validateFieldArray,
	setFieldAttributes,
	addRequirePrintMailMethod,
	removeRequirePrintMailMethod,
    setRepeaterEditing
} from '../WizardActions'
import {noop} from 'utilities'
import * as WizardClasses from '../WizardClasses';
import {Modal} from 'components/Modal/Modal'
import Portal from 'components/Portal/Portal'
import { resolveFieldConditions } from '@tecuity/wizard-utilities'
import FieldTooltip from '../Tooltip'
// import CloneIcon from '@tecuity/sos-icons/react/clone'
// import TrashIcon from '@tecuity/sos-icons/react/trash'
// import RevertIcon from '@tecuity/sos-icons/react/revert'

const disallowedFields = ['Paragraph', 'UploadPlaceholder']
const REPEATER_SHOW_EDIT_BUTTON = process.env.REPEATER_SHOW_EDIT_BUTTON

class Repeater extends Component{
  constructor(){
    super();
    this.state = {adding: false, editing: null};
  }
  componentDidMount = () => {
    if(this.props.isFirst && !this.props.disabled){
      this.focus()
    }
  }
  componentWillReceiveProps = nextProps => {
    if(this.props.value.length !== nextProps.value.length){
      const printMailRequiredIf = this.props.printMailRequiredIf;
      switch (printMailRequiredIf) {
        case '>1':
          if(nextProps.value.length > 1 && !this.props.requirePrintMailMethod.has(this.props.fieldId)){
            this.props.addRequirePrintMailMethod(this.props.fieldId)
          }else if(nextProps.value.length <= 1 && this.props.requirePrintMailMethod.has(this.props.fieldId)){
            this.props.removeRequirePrintMailMethod(this.props.fieldId)
          }
          break;
        case '>2':
          if(nextProps.value.length > 2 && !this.props.requirePrintMailMethod.has(this.props.fieldId)){
            this.props.addRequirePrintMailMethod(this.props.fieldId)
          }else if(nextProps.value.length <= 2 && this.props.requirePrintMailMethod.has(this.props.fieldId)){
            this.props.removeRequirePrintMailMethod(this.props.fieldId)
          }
          break;
      }
    }
  }
  toggleAdding = () => {
    if(!this.state.adding){
      this.props.template.forEach(fieldId => {
      	let fieldClass = this.props.fields[fieldId].fieldClass
				const {value: _, ...propsLessValue} = this.props.fields[fieldId]
      	let instance = new WizardClasses[fieldClass](propsLessValue)
        let value = this.props.fields[fieldId].defaultValue !== '' ? this.props.fields[fieldId].defaultValue : instance.value;
        if(fieldClass === 'Paragraph'){value = this.props.fields[fieldId].value}
				if(fieldClass === 'AddressBlock'){
					value = {
            ...instance.value,
            STATE: this.props.fields[fieldId].defaultState || instance.value.STATE
          }
				}
      	this.props.setFieldAttributes({
      		fieldId,
      		payload: {
      			value,
						infoMessage: instance.infoMessage,
      			isValid: null,
      			confirmed: instance.confirmed,
      			feedback: instance.feedback,
      			errorMessage: instance.errorMessage
      		}
      	})
      })
    }
    this.setState({adding: !this.state.adding})
  }
  addRow = callback => {
    validateFieldArray(buildFieldIdList(this.props.template), (isValid)=>{
      callback(isValid)
      if(isValid){
        let rows = [
          ...this.props.value,
          this.buildRow(1)
        ]
        this.props.onChange(rows, null, {}, undefined, {triggerOnAdvanceValidation: true})
        this.setState({adding: false})
      }
    }, { isSavingRepeater: true })
  }
  buildRow = (status, props={}) => {
    let row = {};
    this.props.templateFields.forEach((field)=>{
			if(props.resolveConditions){
				if(resolveFieldConditions(field.conditions, this.props.fields, field.conditionsOperator)){
					row[field.fieldId] = field.value
				}else{
					const fieldClass = field.fieldClass
	      	const instance = new WizardClasses[fieldClass]()
	        const value = field.defaultValue !== '' ? field.defaultValue : instance.value;
					row[field.fieldId] = value
				}
			}else{
				row[field.fieldId] = field.value
			}
    })
    row._rowId = shortid.generate()
    row._statusId = status === 0 ? 0 : status ? status : 1;
    return row;
  }
  editRow = (rowIndex) => {
    if(this.props.value[rowIndex]._statusId !== 3){
      this.props.template.forEach(fieldId => {
				let fieldClass = this.props.fields[fieldId].fieldClass
				let value = this.props.value[rowIndex][fieldId]
				if(fieldClass === 'Paragraph'){value = this.props.fields[fieldId].value}
      	this.props.setFieldAttributes({
      		fieldId,
      		payload: {
      			value,
      			isValid: null,
      			confirmed: false,
      			feedback: null,
      			errorMessage: ''
      		}
      	})
      })
      this.setState({editing: rowIndex})
        this.props.setRepeaterEditing(true)
    }
  }
  saveRow = (rowIndex, callback) => {
    validateFieldArray(buildFieldIdList(this.props.template), (isValid)=>{
      callback(isValid)
      if(isValid){
        let rows = [
          ...this.props.value.slice(0, rowIndex),
          {
            ...this.buildRow(null, {resolveConditions: true}),
            ...(Object.keys(this.props.value[rowIndex]).reduce((obj, key) => {
              //if(key.charAt(0) === "_"){
              if(key === '_statusId' || key === '_rowId' || key === '_original' || key === '_partyId') {
                obj[key] = this.props.value[rowIndex][key];
              }
              return obj;
            }, {})),
            _statusId: this.props.value[rowIndex]._statusId === 0 || this.props.value[rowIndex]._original ? 2 : 1,
            _dirty: true,
            _original: this.props.value[rowIndex]._original,
            _rowId: this.props.value[rowIndex]._rowId
          },
          ...this.props.value.slice(rowIndex + 1)
        ]
        this.props.onChange(rows, null, {rowErrors: null}, undefined, {triggerOnAdvanceValidation: true})
        this.setState({editing: null})
          this.props.setRepeaterEditing(false)
      }
    }, { isSavingRepeater: true })
  }
  deleteRow = rowIndex => {
    let rows;
    if(this.props.trackChanges && this.props.value[rowIndex]._original){
			const currentRow = this.props.value[rowIndex]
	    const originalRow = this.props.original.find(r => r._rowId === currentRow._rowId)
      rows = [
        ...this.props.value.slice(0, rowIndex),
        {
          ...originalRow,
          _statusId: 3
        },
        ...this.props.value.slice(rowIndex + 1)
      ]
		}else{
			rows = [
	      ...this.props.value.slice(0, rowIndex),
	      ...this.props.value.slice(rowIndex + 1)
	    ]
		}
    this.props.onChange(rows, null, {}, undefined, {triggerOnAdvanceValidation: true})
  }
  revertRow = rowIndex => {
    const currentRow = this.props.value[rowIndex]
    const originalRow = this.props.original.find(r => r._rowId === currentRow._rowId)
    const rows = [
      ...this.props.value.slice(0, rowIndex),
      {...originalRow},
      ...this.props.value.slice(rowIndex + 1)
    ]
    this.props.onChange(rows, null)
  }
  cloneRow = rowIndex => {
    const rowToClone = this.props.value[rowIndex]
    const filteredRow = Object.keys(rowToClone)
      //.filter((key) => !key.startsWith('_'))
      .filter((key) => key !== '_statusId' && key !== '_rowId' && key !== '_original' && key !== '_partyId')
      .reduce((obj, key) => {
        obj[key] = rowToClone[key]
        return obj
      }, {})
    let rows = [
      ...this.props.value.slice(0, rowIndex),
      ...this.props.value.slice(rowIndex),
      { ...filteredRow, _rowId: shortid.generate(), _statusId: 1, _original: false },
    ]
    this.props.onChange(rows, null, {}, undefined, { triggerOnAdvanceValidation: true })
  }
  cancelEdit = () => {
    this.setState({editing: null})
      this.props.setRepeaterEditing(false)
  }
  focus = () => {
    try {
			if(this.props.value.length > 0){
	      this.firstRow.focus()
	    }else{
	      if(!this.props.disableAdding){
					this.addButton.focus()
				}
	    }
    } catch (e) {
    	console.warn("Attempted to focus unfocusable element.")
    }
  }
  render(){
		const {
			tooltip,
			templateFields=[],
			disabled,
			emptyRepeaterLabel,
			businessRules = [],
			value,
			disableAdding,
			disableCloning,
			disableDeleting,
      disableEditing,
      rowErrors,
      trackChanges,
			customDeleteLabel,
			noDeletedStyling,
			addButtonLabel,
			maxRepeaterRows
		} = this.props
		const hasMaxRows = maxRepeaterRows !== undefined ? true : businessRules.find(rule => rule.fn === 'repeaterMaxRows')
		const maxRows = hasMaxRows ? maxRepeaterRows !== undefined ? maxRepeaterRows : hasMaxRows.props.maxRows : null
		const numRows = value.filter((row) => row._statusId !== 3).length
		const editingDisabled = disabled ? disabled : hasMaxRows ? numRows >= maxRows : disabled
		const filteredFields = templateFields.filter(field => !disallowedFields.includes(field.fieldClass) && field.active && !field.hideInRepeaterGrid)
    return(
      <div className={`repeater ${disabled ? 'disabled' : ''}`}>
				{tooltip !== '' && tooltip ? <FieldTooltip tooltip={tooltip} /> : null}
        <div className="repeats">
          <div className="scrollable">
						<table className="form-table">
	            <thead>
	              <tr className="repeats-row">
	                {
	                   filteredFields.map((field, i) => (
	                     <th key={i}>{field.shortLabel !== '' ? field.shortLabel : field.label}</th>
	                  ))
	                }
	                {
	                  (!editingDisabled || !disableDeleting || !disableCloning) && this.props.value.length > 0 && !disabled &&
	                  <th><span className="visually-hidden">Actions</span></th>
	                }
	              </tr>
	            </thead>
	            <tbody>
	              {
	                this.props.value.length === 0 ?
		                <tr className="repeats-row">
										  <td className="no-entries" colSpan={filteredFields.length}>
										    {emptyRepeaterLabel === '' ? 'None' : emptyRepeaterLabel}
										  </td>
										</tr>
	                  :
	                  this.props.value.map((row, i) => (
	                    <TableRow
	                      onChange={this.setEditValue}
	                      templateFields={templateFields}
	                      cancelEdit={this.cancelEdit}
	                      saveRow={this.saveRow}
	                      cloneRow={this.cloneRow}
	                      deleteRow={this.deleteRow}
	                      revertRow={this.revertRow}
	                      editRow={this.editRow}
	                      row={row}
	                      editing={this.state.editing === i}
	                      disabled={disabled}
	                      editDisabled={disableEditing}
	                      cloneDisabled={editingDisabled === true ? true : disableCloning}
												deleteDisabled={disableDeleting}
												customDeleteLabel={customDeleteLabel}
												noDeletedStyling={noDeletedStyling}
	                      errors={rowErrors ? rowErrors[i] : null}
	                      trackChanges={trackChanges}
	                      rowIndex={i}
	                      ref={rowRef => {if(i === 0){this.firstRow = rowRef}}}
	                      key={i}
	                    />
	                  ))
	              }
	            </tbody>
	          </table>
					</div>
          {
            !disabled && !disableAdding &&
            <div className="row">
            	<div className="col-sm-4 col-md-3 col-lg-3">
            		<button
            			className="btn btn-raised btn-primary form-button add-row"
            			disabled={editingDisabled || disableAdding}
            			type="button"
            			onClick={this.toggleAdding}
                  ref={addButton => {this.addButton = addButton}}
                >
            			{addButtonLabel || 'Add'}
            		</button>
            	</div>
            </div>
          }
          <AddSection
          	ref={r => {
          		this.addSection = r
          	}}
            open={this.state.adding}
          	templateFields={templateFields}
          	addRow={this.addRow}
          	toggleAdding={this.toggleAdding}
          />
        </div>
      </div>
    )
  }
}
export default connect(
  (state, props)=>({
    fields: state.wizard.wizard.fields,
    templateFields: props.template.map((fieldId)=>(state.wizard.wizard.fields[fieldId])),
    requirePrintMailMethod: state.wizard.requirePrintMailMethod,
    original: state.wizard.diff.originalByFieldId[props.fieldId]
  }),
  { setFieldAttributes, addRequirePrintMailMethod, removeRequirePrintMailMethod, setRepeaterEditing }
)(Repeater)

class AddSection extends Component{
  state = {
    open: false
  }
  componentWillReceiveProps = nextProps => {
    if(this.props.open == false && nextProps.open === true){
      this.setState({
        open: true
      })
    }
  }
  closeModal = () => {
    this.modal.closeModal(() => {
      this.closePortal()
    })
  }
  closePortal = () => {
    this.setState({open: false})
    if(this.props.open){
      this.props.toggleAdding()
    }
  }
  addRow = () => {
    this.props.addRow(isValid => {
      if(isValid){
        this.closeModal()
      }
    })
  }
  render(){
    const { templateFields } = this.props;
    return(
      <Portal isOpened={this.state.open}>
      	<Modal
      		ref={r => {
      			this.modal = r
      		}}
      		closeButton
      		closeModal={this.closePortal}
      		modalSize="large"
      		modalBodyClassName="wizard relative-modal"
      		title="Add"
      		autoHeight>
      		<div className="template sub-section">
      			<div className="template-fields">
      				{templateFields.map((field, i) => {
      					if (field) {
      						return field.active ? <Field field={field} key={field.fieldId} /> : null
      					} else {
      						console.warn(`Attempted to render Repeater subfield at index ${i} but got null.`)
      						return null
      					}
      				})}
      			</div>
      			<div className="controls">
      				{/* <button type="button" className="btn text-btn" onClick={toggleAdding}>Cancel</button> */}
      				<button type="button" className="btn btn-raised btn-primary" onClick={this.addRow}>
      					Save
      				</button>
      			</div>
      		</div>
      	</Modal>
      </Portal>
    )
  }
}

class TableRow extends Component {
  editRow = e => {
    // e.stopPropagation();
    if (!this.props.editing) this.props.editRow(this.props.rowIndex)
  }
  setEditValue = e => {
    this.props.onChange(e)
  }
  saveRow = (e, callback) => {
    e.stopPropagation()
    this.props.saveRow(this.props.rowIndex, callback)
  }
  cancelEdit = () => {
    this.props.cancelEdit()
  }
  deleteRow = e => {
    e.stopPropagation()
    this.props.deleteRow(this.props.rowIndex)
  }
  revertRow = e => {
    e.stopPropagation()
    this.props.revertRow(this.props.rowIndex)
  }
  cloneRow = e => {
    e.stopPropagation()
    this.props.cloneRow(this.props.rowIndex)
  }
  checkForSubmit = e => {
    if ((e.charCode === 13 || e.charCode === 32) && e.target.tagName === 'TR') {
      e.preventDefault()
      this.editRow()
    }
  }
  focus = () => {
    this.row.focus()
  }
  render() {
    const {
      row,
      templateFields,
      editing,
      fields,
      disabled,
      cloneDisabled,
      deleteDisabled,
      editDisabled,
      errors,
      trackChanges,
      customDeleteLabel,
      noDeletedStyling
    } = this.props
    let filteredColumns = Object.keys(row)
      //.filter((key) => key.charAt(0) !== "_")
      .filter(key => key !== '_statusId' && key !== '_rowId' && key !== '_original' && key !== '_partyId')
      .filter(item => fields[item] ? (!disallowedFields.includes(fields[item].fieldClass) && !fields[item].hideInRepeaterGrid) : false)

    const deleting = row._statusId === 3
    const added = row._statusId === 1
    const edited = row._statusId === 2
    return (
      <tr
        role={editing || disabled || deleting || editDisabled ? '' : 'button'}
        tabIndex={disabled || deleting || editDisabled ? '' : 0}
        className={`not-editing repeats-row ${
          deleting && trackChanges ? `deleting ${noDeletedStyling ? 'no-delete' : ''}` : ''
        } ${added && trackChanges ? 'adding' : ''} ${edited && trackChanges ? 'edited' : ''} ${
          disabled || editDisabled ? 'disabled' : ''
        }`}
        onClick={editing || disabled || editDisabled ? noop : this.editRow}
        onKeyPress={editing || disabled || editDisabled ? noop : this.checkForSubmit}
        ref={row => {
          this.row = row
        }}
      >
        {filteredColumns.map((fieldId, i) => {
          let field = fields[fieldId]
          const { fieldClass, textAlignment = 'left' } = field
          return field.active ? (
            <td className="repeats-column" key={fieldId} style={{ textAlign: textAlignment }}>
              {errors && errors.cellValids[fieldId]
                ? errors.cellValids[fieldId].isValid === false && (
                    <span className="error-badge">!</span>
                  )
                : null}
              {new WizardClasses[fieldClass]().getHumanReadableValue(field, row[fieldId]) === "[Select An Option]" ? "" : new WizardClasses[fieldClass]().getHumanReadableValue(field, row[fieldId])}
            </td>
          ) : null
        })}
        <EditModal
          open={editing}
          row={row}
          errors={errors}
          templateFields={templateFields}
          saveRow={this.saveRow}
          cancelEdit={this.cancelEdit}
          setEditValue={this.setEditValue}
        />
        {!disabled && (!cloneDisabled || !deleteDisabled || (REPEATER_SHOW_EDIT_BUTTON && !editDisabled)) && (
          <td className="row-controls-col">
            <div className="row-controls">
              {REPEATER_SHOW_EDIT_BUTTON && !disabled && !editDisabled && (
                <button type="button" className="btn btn-primary control" onClick={this.editRow}>
                  Edit
                </button>
              )}
              {!deleteDisabled && !disabled && trackChanges && deleting && (
                <button
                  type="button"
                  className={`btn btn-primary control`}
                  disabled={disabled || deleteDisabled}
                  onClick={this.revertRow}
                >
                  {/* <RevertIcon/> */}
                  Revert
                </button>
              )}
              {!cloneDisabled && !disabled && (
                <button
                  type="button"
                  className="btn btn-primary control"
                  disabled={cloneDisabled || disabled}
                  onClick={this.cloneRow}
                >
                  {/* <CloneIcon/> */}
                  Copy
                </button>
              )}
              {!deleteDisabled && !disabled && (!deleting || !trackChanges) && (
                <button
                  type="button"
                  className={`btn btn-danger control`}
                  disabled={disabled || deleteDisabled}
                  onClick={this.deleteRow}
                >
                  {/* <TrashIcon/> */}
                  {customDeleteLabel ? customDeleteLabel : 'Delete'}
                </button>
              )}
            </div>
          </td>
        )}
      </tr>
    )
  }
}

TableRow = connect(
  (state)=>({
    fields: state.wizard.wizard.fields
  }),
  null,
  null,
  { forwardRef: true }
)(TableRow)

class EditModal extends Component {
  state = {
    open: false
  }
  componentWillReceiveProps = nextProps => {
    if(this.state.open === false && nextProps.open === true){
      this.setState({
        open: true
      })
    }
  }
  closeModal = () => {
    this.modal.closeModal(() => {
      this.closePortal()
    })
  }
  closePortal = () => {
    this.setState({open: false})
    if(this.props.open){
      this.props.cancelEdit()
    }
  }
  saveRow = e => {
    this.props.saveRow(e, isValid => {
      if(isValid){
        this.closeModal()
      }
    })
  }
  render(){
    const { templateFields, errors } = this.props;
    return(
      <Portal isOpened={this.state.open}>
      	<Modal
        	ref={r => {
        		this.modal = r
        	}}
        	closeButton
        	closeModal={this.closePortal}
        	modalSize="large"
        	modalBodyClassName="wizard relative-modal"
        	title="Edit"
        	autoHeight>
        	<div className="template sub-section">
        		{templateFields.map((field, i) => {
        			const isValid = errors && errors.cellValids[field.fieldId] ? errors.cellValids[field.fieldId].isValid : field.isValid
        			const cellErrors = errors && errors.cellValids[field.fieldId] ? errors.cellValids[field.fieldId].errors : field.errorMessage
        			return (
        				field.active ?
                <Field
        					field={{
        						...field,
        						isValid: field.isValid === true ? field.isValid : isValid,
        						errorMessage: field.isValid === true ? [] : cellErrors
        					}}
        					key={field.fieldId}
        				/>
                : null
        			)
        		})}
        		<div className="controls">
        			<button type="button" className="btn btn-raised btn-primary" onClick={this.saveRow}>
        				Save
        			</button>
        		</div>
        	</div>
        </Modal>
        </Portal>
    )
  }
}
EditModal = connect(
  state=>({
    fields: state.wizard.wizard.fields
  })
)(EditModal)

export const DumbRow = ({row}) => (
  <tr>
    {
      Object.keys(row).map((key, k) => (
        <td key={k}>
          {row[key]}
        </td>
      ))
    }
  </tr>
)



// WEBPACK FOOTER //
// ./src/components/Wizard2/fieldComponents/Repeater.js